export default __webpack_public_path__ + "static/media/facebookDeskFill.11c8f571.svg";